import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PropTypes from 'prop-types';
import * as Styles from './index.styles';

export const Icon = ({ icon, padLeft, padRight, onClick, className, ...otherProps }) => {
    return (
        <Styles.StyledIcon
            className={className}
            padLeft={padLeft}
            padRight={padRight}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={icon} {...otherProps} />
        </Styles.StyledIcon>
    );
};

Icon.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.shape({}),
        PropTypes.object,
    ]).isRequired,
    padLeft: PropTypes.bool,
    padRight: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

Icon.defaultProps = {
    padLeft: false,
    padRight: false,
    onClick: () => {},
    className: '',
};

Icon.Styles = Styles;
